import Badge from '@/components/molecules/item/model/badge'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { BadgeListDisplayPolicy } from '../display-policy'
import { RuleApplicable } from '../rule-applicable'
import { MyColorBadgeListDisplayPolicy } from './mycolor-policy'

/**
 * 美ラボ・ホテラバ商品一覧用バッジポリシー
 * src/Model/BadgeList/EachPolicy/HlBadgeListDisplayPolicy.php と実装を合わせる
 *
 * ポリシーの仕様やMyColorのポリシーへの処理委譲の経緯などはこちらを参照
 * @see https://github.com/my-color/front/issues/7390#issuecomment-1606544284
 */
export class HlBadgeListDisplayPolicy implements BadgeListDisplayPolicy {

  /**
   * アパレル商品のときに処理を委譲するバッジポリシー
   * ただし、現在の委譲先のMyColorBadgeListDisplayPolicyにおいて在庫状況のバッジは、
   * $behaviorに依存するためにホテラバのポリシーが適用される。
   * @type {BadgeListDisplayPolicy}
   */
  private readonly delegationPolicyForApparel: BadgeListDisplayPolicy

  /**
   * @param {BehaviorConfig} behavior
   * @param {BadgeListDisplayPolicy} [delegationPolicyForApparel]
   * モックを使ってテストするときのみ、この引数を使う
   */
  constructor(
    private readonly behavior: BehaviorConfig,
    delegationPolicyForApparel?: BadgeListDisplayPolicy
  ) {

    this.delegationPolicyForApparel
      = delegationPolicyForApparel || new MyColorBadgeListDisplayPolicy(this.behavior)

  }

  list(policyInput: RuleApplicable): Badge[] {

    if (policyInput.isContactLens) return []

    return this.delegationPolicyForApparel.list(policyInput)
  }
}
